export const communes = [
    {zip:97216, nom:"AJOUPA-BOUILLON"},
    {zip:97217, nom:"ANSES D'ARLET"},
    {zip:97218, nom:"BASSE-POINTE"},
    {zip:97222, nom:"BELLEFONTAINE"},
    {zip:97221, nom:"CARBET"},
    {zip:97222, nom:"CASE-PILOTE"},
    {zip:97223, nom:"DIAMANT"},
    {zip:97224, nom:"DUCOS"},
    {zip:97250, nom:"FOND-SAINT-DENIS"},
    {zip:97200, nom:"FORT-DE-FRANCE"},
    {zip:97240, nom:"FRANCOIS"},
    {zip:97218, nom:"GRAND-RIVIERE"},
    {zip:97213, nom:"GROS-MORNE"},
    {zip:97232, nom:"LAMENTIN"},
    {zip:97214, nom:"LORRAIN"},
    {zip:97218, nom:"MACOUBA"},
    {zip:97225, nom:"MARIGOT"},
    {zip:97290, nom:"MARIN"},
    {zip:97260, nom:"MORNE-ROUGE"},
    {zip:97226, nom:"MORNE-VERT"},
    {zip:97250, nom:"PRECHEUR"},
    {zip:97211, nom:"RIVIERE-PILOTE"},
    {zip:97215, nom:"RIVIERE-SALEE"},
    {zip:97231, nom:"ROBERT"},
    {zip:97270, nom:"SAINT-ESPRIT"},
    {zip:97212, nom:"SAINT-JOSEPH"},
    {zip:97250, nom:"SAINT-PIERRE"},
    {zip:97227, nom:"SAINTE-ANNE"},
    {zip:97228, nom:"SAINTE-LUCE"},
    {zip:97230, nom:"SAINTE-MARIE"},
    {zip:97233, nom:"SCHOELCHER"},
    {zip:97220, nom:"TRINITE"},
    {zip:97229, nom:"TROIS-ILETS"},
    {zip:97280, nom:"VAUCLIN"}
]
export const banques = ["Banque Postale","Bred","BNP","Caisse d'épargne", "Crédit Agricole", "Crédit Mutuel", "LCL", "Crédit maritime", "Autre banque"]

//types (alertes, comptes, versements, etc)
export const alert_types = ['erreur', 'action requise']

export const eglise_compte_type= ['banque','interne']
export const compte_type = ['banque', 'liaison', 'petite-caisse', 'interne']
export const fedcompte_type = ['dîme', 'offrande fédérale', 'caisse', 'institution', 'catastrophes naturelles']
export const fedVerseTypes=[
    {value:'siege', label:"Siège FEAM"},
    {value:'banque', label:"Banque FEAM"},
    {value:'virement', label:"Virement"},
    {value:'cheque', label:"Chèque"}
]

//classification dépenses
export const COMPTES_DE_CHARGES	 = [
    { num_compte: "6257100000", libelle: "Dépenses pour la Sainte cène" },
    { num_compte: "6234020000", libelle: "Gerbe, cadeaux et autres marques d'affection (gratification)"},
    { num_compte: "6063000000", libelle: "Déco-Produits d'entretien - petits équipements et divers" },
    { num_compte: "6257000000", libelle: "Repas collation divers - Eau de source - boissons" },
    { num_compte: "6150000000", libelle: "Petit travaux - entretien espaces verts" },
    { num_compte: "6061010000", libelle: "Odyssi-SME" },
    { num_compte: "6061020000", libelle: "EDF" },
    { num_compte: "6064000000", libelle: "papier machine - encre - fournitures de bureau" },
    { num_compte: "6280000000", libelle: "Activités diverses fédérale" },
    { num_compte: "6280000000", libelle: "Activités diverses local" },
    { num_compte: "6251000000", libelle: "Déplacement-mission-défraiement" },
    { num_compte: "6234010000", libelle: "Réalisation de dépliants, tracts, cartes etc." },
    { num_compte: "6238010000", libelle: "Divers dons" },
    { num_compte: "6261000000", libelle: "Téléphone et internet" },
    { num_compte: "6713030000", libelle: "aide spéciale" },
    { num_compte: "6511040000", libelle: "allocation versée à l'école de Kerlys" },
    { num_compte: "6511050000", libelle: "allocation versée à l'EPAR" },
    { num_compte: "6511060000", libelle: "allocation versée à l'école de St Joseph" },
    { num_compte: "6278000000", libelle: "frais bancaire" },
    { num_compte: "6610000000", libelle: "Intérêts bancaires débiteurs" },
    { num_compte: "7680000000", libelle: "Intérêts créditeurs"},
    { num_compte: "6283010000", libelle: "Bible, questionnaires et autres livres"},
];
  
  
//Rôles et accès
export const access_list = [
    {label:'Consultation des comptes', button_title:'Consulter comptes', ref:"/comptes/consultation"},
    {label:'Enregistrement de dons', button_title:'recettes', ref:"/recettes/enregistrement-des-fonds"},
    {label:'Création de versements', button_title:'versements', ref:"/versements/enregistrement"},
    {label:'Enregistrement de dépenses', button_title:'dépenses', ref:"/depenses/enregistrement"},
    {label:'Encaissement des versements', ref:"/caisse/versements"},
    {label:'Validation versements par transaction bancaire', ref:"/versements/banque"},
    {label:'Clotûre', button_title:'clôture', ref:"/cloture"},
    {label:'Rapports', button_title:'rapports', ref:"/rapports"},
    {label:'Journal des dons', button_title:'journal des recettes', ref:"/journal/dons"},
    {label:'Journal des versements', button_title:'journal des versements', ref:"/journal/versements"},
    {label:'Journal des dépenses', button_title:'journal des dépenses', ref:"/journal/depenses"},
    {label:'Journal de petite caisse', button_title:'journal de petite caisse', ref:"/journal/petite-caisse"},
    {label:'Journal des virements', button_title:'journal des virements', ref:"/journal/virements"},
    {label:'Don web/bornes', button_title:'dons web/bornes', ref:"/web&bornes"},
    {label:'Grand Livre', button_title:'Grand livre', ref:"/journal/global"},
    {label:'Gestion des donateurs', button_title:'', ref:"/donateurs"},
    {label:'CERFA - attestations fiscales', button_title:'CERFA', ref:"/cerfa"},
    {label:'Gestion des comptes', button_title:'', ref:"/comptes"},
    {label:'Gestion des utilisateurs', button_title:'', ref:"/users"},
    {label:'Gestion des églises', button_title:'', ref:"/eglises"},
    {label:'Gestion des régions', button_title:'', ref:"/regions"},
    {label:'Gestion base de données', button_title:'', ref:"/dada-base"},
    {label:'Export EBP', button_title:'', ref:"/export/ebp"},
    {label:'Gestion des alertes', button_title:'', ref:"/alertes"},
    {label:'Clôture annuelle et création nouvelle année', ref:"cloture_newyear"},
    {label:'Caisse', ref:"/caisse"},
    {label:'Dépenses courantes', button_title:'Dépenses courantes', ref:"/depenses/courantes"},
    {label:'Abonnements (dépenses)', button_title:'Abonnements', ref:"/depenses/abonnements"},
    {label:'Gestion des fournisseurs', button_title:'Fournisseurs', ref:"/fournisseurs"},
    {label:'Journaux d\'activité', button_title:'Logs', ref:"/logs"},
    //Esdras management
    {label:'Gestion des commandes Esdras', button_title:'Commandes', ref:"/esdras/commandes"},
    {label:'Gestion des billets emis', button_title:'Billets', ref:"/esdras/billets"},
    {label: 'Gestion des projet et évènements', button_title:'Évènements et Projets', ref:"/esdras/projects"},
]
export const roles = [
    {label: "assistant", level:1, access_max:[
        {label:'Consultation des comptes', ref:"/comptes/consultation"},
        {label:'Enregistrement de dons', ref:"/recettes/enregistrement-des-fonds"},
        {label:'Création de versements', ref:"/versements/enregistrement"},
        {label:'Enregistrement de dépense', ref:"/depenses/enregistrement"},
        {label:'Rapports', ref:"/rapports"},
        {label:'Grand Livre', ref:"/journal/global"},
        {label:'Journal des dons', ref:"/journal/dons"},
        {label:'Journal des versements', ref:"/journal/versements"},
        {label:'Journal des dépenses', ref:"/journal/depenses"},
        {label:'Journal de petite caisse', ref:"/journal/petite-caisse"},
        {label:'Journal des virements', ref:"/journal/virements"},
        {label:'Don web/bornes', button_title:'dons web/bornes', ref:"/web&bornes"},
        {label:'Gestion des donateurs', ref:"/donateurs"},
    ]},
    {label: "trésorier", level:2, access_max: [
        {label:'Consultation des comptes', ref:"/comptes/consultation"},
        {label:'Enregistrement de dons', ref:"/recettes/enregistrement-des-fonds"},
        {label:'Création de versements', ref:"/versements/enregistrement"},
        {label:'Enregistrement de dépense', ref:"/depenses/enregistrement"},
        {label:'Clotûre', ref:"/cloture"},
        {label:'Rapports', ref:"/rapports"},
        {label:'Grand Livre', ref:"/journal/global"},
        {label:'Journal des dons', ref:"/journal/dons"},
        {label:'Journal des versements', ref:"/journal/versements"},
        {label:'Journal des dépenses', ref:"/journal/depenses"},
        {label:'Journal de petite caisse', ref:"/journal/petite-caisse"},
        {label:'Journal des virements', ref:"/journal/virements"},
        {label:'Don web/bornes', button_title:'dons web/bornes', ref:"/web&bornes"},
        {label:'Gestion des donateurs', ref:"/donateurs"},
        {label:'Gestion des comptes', ref:"/comptes"},
        {label:'Gestion des utilisateurs', ref:"/users"},
    ]},
    {label: "gestionnaire", level:3, access_max: [
        {label:'Consultation des comptes', button_title:'Consulter comptes', ref:"/comptes/consultation"},
        {label:'Enregistrement de dons', button_title:'recettes', ref:"/recettes/enregistrement-des-fonds"},
        {label:'Création de versements', button_title:'versements', ref:"/versements/enregistrement"},
        {label:'Validation versements par transaction bancaire', ref:"/versements/banque"},
        {label:'Enregistrement de dépense', button_title:'dépenses', ref:"/depenses/enregistrement"},
        {label:'Clotûre', button_title:'clôture', ref:"/cloture"},
        {label:'Rapports', button_title:'rapports', ref:"/rapports"},
        {label:'Journal des dons', button_title:'journal des recettes', ref:"/journal/dons"},
        {label:'Journal des versements', button_title:'journal des versements', ref:"/journal/versements"},
        {label:'Journal des dépenses', button_title:'journal des dépenses', ref:"/journal/depenses"},
        {label:'Journal de petite caisse', button_title:'journal de petite caisse', ref:"/journal/petite-caisse"},
        {label:'Journal des virements', button_title:'journal des virements', ref:"/journal/virements"},
        {label:'Don web/bornes', button_title:'dons web/bornes', ref:"/web&bornes"},
        {label:'Grand Livre', button_title:'Grand livre', ref:"/journal/global"},
        {label:'Gestion des donateurs', button_title:'', ref:"/donateurs"},
        {label:'Gestion des comptes', button_title:'', ref:"/comptes"},
        {label:'Gestion des utilisateurs', button_title:'', ref:"/users"},
        {label: 'Export EBP', button_title:'', ref:"/export/ebp"},
        {label:'Clôture annuelle et création nouvelle année', ref:"cloture_newyear"},
        {label:'Dépenses courantes', ref:"/depenses/courantes"},
        {label:'Abonnements (dépenses)', ref:"/depenses/abonnements"},
        {label:'Gestion des fournisseurs', button_title:'Fournisseurs', ref:"/fournisseurs"},
    ]},
    {label: "vérificateur", level:3, access_max:[
        {label:'Consultation des comptes', button_title:'Consulter comptes', ref:"/comptes/consultation"},
        {label:'Enregistrement de dons', button_title:'recettes', ref:"/recettes/enregistrement-des-fonds"},
        {label:'Création de versements', button_title:'versements', ref:"/versements/enregistrement"},
        {label:'Enregistrement de dépense', button_title:'dépenses', ref:"/depenses/enregistrement"},
        {label:'Clotûre', button_title:'clôture', ref:"/cloture"},
        {label:'Rapports', button_title:'rapports', ref:"/rapports"},
        {label:'Journal des dons', button_title:'journal des recettes', ref:"/journal/dons"},
        {label:'Journal des versements', button_title:'journal des versements', ref:"/journal/versements"},
        {label:'Journal des dépenses', button_title:'journal des dépenses', ref:"/journal/depenses"},
        {label:'Journal de petite caisse', button_title:'journal de petite caisse', ref:"/journal/petite-caisse"},
        {label:'Journal des virements', button_title:'journal des virements', ref:"/journal/virements"},
        {label:'Don web/bornes', button_title:'dons web/bornes', ref:"/web&bornes"},
        {label:'Grand Livre', button_title:'Grand livre', ref:"/journal/global"},
        {label:'Gestion des donateurs', button_title:'', ref:"/donateurs"},
        {label:'Gestion des comptes', button_title:'', ref:"/comptes"},
        {label:'Gestion des utilisateurs', button_title:'', ref:"/users"},
        {label:'Gestion des églises', button_title:'', ref:"/eglises"},
        {label: 'Export EBP', button_title:'', ref:"/export/ebp"},
        {label:'Clôture annuelle et création nouvelle année', ref:"cloture_newyear"},
        {label:'Dépenses courantes', ref:"/depenses/courantes"},
        {label:'Abonnements (dépenses)', ref:"/depenses/abonnements"},
        {label:'Gestion des fournisseurs', button_title:'Fournisseurs', ref:"/fournisseurs"},
    ]},
    {label: "caissier", level:3, access_max:[
        {label:'Caisse', ref:"/caisse"},
        {label:'Consultation des comptes', button_title:'Consulter comptes', ref:"/comptes/consultation"},
        {label:'Création de versements', button_title:'versements', ref:"/versements/enregistrement"},
        {label:'Enregistrement de dépense', button_title:'dépenses', ref:"/depenses/enregistrement"},
        {label:'Encaissement des versements', ref:"/caisse/versements"},
        {label:'Validation versements par transaction bancaire', ref:"/versements/banque"},
        {label:'Clotûre', button_title:'clôture', ref:"/cloture"},
        {label:'Rapports', button_title:'rapports', ref:"/rapports"},
        {label:'Journal des dons', button_title:'journal des recettes', ref:"/journal/dons"},
        {label:'Journal des versements', button_title:'journal des versements', ref:"/journal/versements"},
        {label:'Journal des dépenses', button_title:'journal des dépenses', ref:"/journal/depenses"},
        {label:'Journal de petite caisse', button_title:'journal de petite caisse', ref:"/journal/petite-caisse"},
        {label:'Journal des virements', button_title:'journal des virements', ref:"/journal/virements"},
        {label:'Don web/bornes', button_title:'dons web/bornes', ref:"/web&bornes"},
        {label:'Grand Livre', button_title:'Grand livre', ref:"/journal/global"},
        {label:'Gestion des donateurs', button_title:'', ref:"/donateurs"},
        {label:'Gestion des comptes', button_title:'', ref:"/comptes"},
        {label:'Gestion des utilisateurs', button_title:'', ref:"/users"},
        {label: 'Export EBP', button_title:'', ref:"/export/ebp"},
        {label:'Clôture annuelle et création nouvelle année', ref:"cloture_newyear"},
        {label:'Gestion des fournisseurs', button_title:'Fournisseurs', ref:"/fournisseurs"},
    ]},
    {label: "administrateur", level:4, access_max:[
        {label:'Consultation des comptes', button_title:'Consulter comptes', ref:"/comptes/consultation"},
        {label:'Enregistrement de dons', button_title:'recettes', ref:"/recettes/enregistrement-des-fonds"},
        {label:'Création de versements', button_title:'versements', ref:"/versements/enregistrement"},
        {label:'Enregistrement de dépense', button_title:'dépenses', ref:"/depenses/enregistrement"},
        {label:'Encaissement des versements', ref:"/caisse/versements"},
        {label:'Validation versements par transaction bancaire', ref:"/versements/banque"},
        {label:'Clotûre', button_title:'clôture', ref:"/cloture"},
        {label:'Rapports', button_title:'rapports', ref:"/rapports"},
        {label:'Journal des dons', button_title:'journal des recettes', ref:"/journal/dons"},
        {label:'Journal des versements', button_title:'journal des versements', ref:"/journal/versements"},
        {label:'Journal des dépenses', button_title:'journal des dépenses', ref:"/journal/depenses"},
        {label:'Journal de petite caisse', button_title:'journal de petite caisse', ref:"/journal/petite-caisse"},
        {label:'Journal des virements', button_title:'journal des virements', ref:"/journal/virements"},
        {label:'Don web/bornes', button_title:'dons web/bornes', ref:"/web&bornes"},
        {label:'Grand Livre', button_title:'Grand livre', ref:"/journal/global"},
        {label:'Gestion des donateurs', button_title:'', ref:"/donateurs"},
        {label:'Gestion des comptes', button_title:'', ref:"/comptes"},
        {label:'Gestion des utilisateurs', button_title:'', ref:"/users"},
        {label:'Gestion des églises', button_title:'', ref:"/eglises"},
        {label:'Gestion des régions', button_title:'', ref:"/regions"},
        {label:'Export EBP', button_title:'', ref:"/export/ebp"},
        {label:'Clôture annuelle et création nouvelle année', ref:"cloture_newyear"},
        {label:'Dépenses courantes', ref:"/depenses/courantes"},
        {label:'Abonnements (dépenses)', ref:"/depenses/abonnements"},
        {label:'Gestion des fournisseurs', ref:"/fournisseurs"},
        {label:'Journaux d\'activité', ref:"/logs"},
        {label:'CERFA - attestations fiscales', ref:"/cerfa"},
    ]},
    {label: "super administrateur", level:5, access_max: access_list},
]

//Card synchrohinaisation
export const EGLISE_CARD_INFO_LIST = [{title:'Nom', value:eglise=>eglise.nom}, {title:'Commune', value:eglise=>eglise.commune}]

//Journaux EBP
export const CODE_ANALYTIQUE_EGLISES = [
    "PHILADELPHIA", "BERIYTH", "AJOUPABOUILLO", "BASSEPOINTE", "BELEME",
    "BELLEFONTAINE", "BETHANIE", "BETHEL", "BONAIR", "BAUDELRENEE",
    "CALIFORNIE", "CARABIN", "CARBET", "CASEPILOTE", "CHAPELSTJOSEP",
    "CHAPELVILARSO", "CITELACROIX", "CORIDON", "DERRIEREMORNE", "DIAMANT",
    "DOMINANTE", "DUCOS", "EPHESE", "EPINAY", "ERMITAGE", "EUDORCAIT",
    "FONDSSAVANE", "FRANCOIS", "GRANDRIVIERE", "GONDEAULAMENT", "GONDEAUSTJOSE",
    "GROSMORNE", "HOREB", "LAHAUT", "LAMENTIN", "LESTRADE", "LORRAIN",
    "MARANATHA", "MARIGOT", "MARIN", "MORNEDESOLIVE", "MORNECAPOT",
    "MORIJA", "MORNESDESSES", "MORNEPITAULT", "MORNEPOIRIER", "MORNEROUGE",
    "MORNEVERT", "PAINDESUCRE", "PEROU", "PETITEANSE", "PRECHEUR",
    "RAVINETOUZA", "RECULEE", "RIVIERELOR", "RIVIEREPILOTE", "RIVIERESALEE",
    "ROBERT", "SAINTESPRIT", "SAINTJACQUES", "SAINTJOSEPH", "SAINTELUCE",
    "SAINTEMARIE", "SAINTPIERRE", "SMYRNE", "TRACEE", "TRINITE", "TROISILETS",
    "VAUCLIN", "VERRIER", "VERTPRE", "VOLGA", "EPHRAÏM"
];
  
